import { Form } from "react-bootstrap"

import Service from "../../../../api/Administration/Model/Service"
import { ServiceCode } from "../../../../api/LookupCodes/ServiceCode"

interface CHSServiceProps {
  service: Service
  selected: boolean
  disabled: boolean
  onSelectService: (serviceCode: ServiceCode, add: boolean) => void
}

function CHSService(props: CHSServiceProps) {
  const {
    service: { ServiceID, ServiceDescription, FFServiceCode },
    selected,
    disabled,
    onSelectService,
  } = props

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelectService(e.target.value as ServiceCode, e.target.checked)
  }

  return (
    <Form.Check
      id={`${FFServiceCode}_${ServiceID}`}
      label={ServiceDescription}
      type="checkbox"
      name="service"
      className="font-weight-bold abc-checkbox-primary abc-checkbox"
      disabled={disabled}
      value={FFServiceCode}
      onChange={onChange}
      checked={selected}
    />
  )
}

export default CHSService
